import { render, staticRenderFns } from "./HistoryMessages.vue?vue&type=template&id=695087fb&"
import script from "./HistoryMessages.vue?vue&type=script&lang=js&"
export * from "./HistoryMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports